import { cs } from '../../../lib/currency';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';
import { CheckCircle, XCircle } from 'lucide-react';

export const SummaryTab = ({ tournament, registrations, totalCollected, expenseSummary }) => {
  const totalRegistered = registrations.length;
  const paidCount = registrations.filter(r => r.payment_status === 'paid').length;
  const unpaidCount = registrations.filter(r => !r.payment_status || r.payment_status === 'unpaid' || r.payment_status === 'pending').length;

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <Card>
        <CardHeader><CardTitle>Financial Summary</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="flex justify-between items-center p-3 bg-green-50 rounded-lg">
            <span className="font-medium">Total Collected</span>
            <span className="text-2xl font-bold text-green-600">{cs()}{totalCollected.toFixed(2)}</span>
          </div>
          <div className="flex justify-between items-center p-3 bg-red-50 rounded-lg">
            <span className="font-medium">Total Expenses</span>
            <span className="text-2xl font-bold text-red-600">{cs()}{expenseSummary?.total_expenses?.toFixed(2) || '0.00'}</span>
          </div>
          <div className="flex justify-between items-center p-3 bg-blue-50 rounded-lg">
            <span className="font-medium">Balance</span>
            <span className={`text-2xl font-bold ${(totalCollected - (expenseSummary?.total_expenses || 0)) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
              {cs()}{(totalCollected - (expenseSummary?.total_expenses || 0)).toFixed(2)}
            </span>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle>Registration Summary</CardTitle></CardHeader>
        <CardContent className="space-y-3">
          <div className="flex justify-between items-center"><span>Total Registered</span><Badge variant="outline">{totalRegistered}</Badge></div>
          <div className="flex justify-between items-center"><span className="flex items-center gap-2"><CheckCircle className="h-4 w-4 text-green-600" />Paid (Confirmed)</span><Badge className="bg-green-100 text-green-700">{paidCount}</Badge></div>
          <div className="flex justify-between items-center"><span className="flex items-center gap-2"><XCircle className="h-4 w-4 text-red-600" />Unpaid (Pending)</span><Badge className="bg-red-100 text-red-700">{unpaidCount}</Badge></div>
          <div className="flex justify-between items-center"><span>Expected Revenue</span><span className="font-medium">{cs()}{(totalRegistered * tournament.initial_payment_amount).toFixed(2)}</span></div>
          <div className="flex justify-between items-center"><span>Outstanding</span><span className="font-medium text-red-600">{cs()}{(unpaidCount * tournament.initial_payment_amount).toFixed(2)}</span></div>
        </CardContent>
      </Card>
      {expenseSummary?.by_category && Object.keys(expenseSummary.by_category).length > 0 && (
        <Card className="md:col-span-2">
          <CardHeader><CardTitle>Expenses by Category</CardTitle></CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {Object.entries(expenseSummary.by_category).map(([cat, amount]) => (
                <div key={cat} className="p-3 bg-slate-50 rounded-lg">
                  <p className="text-sm text-slate-500 capitalize">{cat.replace('_', ' ')}</p>
                  <p className="text-lg font-bold">{cs()}{amount.toFixed(2)}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
